import { render, staticRenderFns } from "./El.vue?vue&type=template&id=9943e2d2&scoped=true&"
import script from "./El.vue?vue&type=script&lang=js&"
export * from "./El.vue?vue&type=script&lang=js&"
import style0 from "./El.vue?vue&type=style&index=0&id=9943e2d2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9943e2d2",
  null
  
)

export default component.exports